import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';

/**
 * @class Slider
 *   
 * @method constructor
 *     @param {HTMLElement} el
 *
 * Create a slider with buttons
 */
export default class Slider {
    constructor (el) {
        this.el = el;
        this.slider = null;

        this.mq = window.matchMedia('(max-width: 1023px)');

        this.init();

        this.mq.addEventListener('change', () => {
            if (this.mq.matches) {
                this.destroy();
            } else {
                this.init();
            }
        });
    }

    getSlideHeight () {
        const slide = this.el.querySelector('.swiper-slide-active');
        const slideHeight = slide.offsetHeight + 'px';

        this.el.style.setProperty('--slideHeight', slideHeight);
    }

    init () {
        if (this.slider || this.mq.matches) return;

        this.slider = new Swiper(this.el, {
            modules: [Navigation, Keyboard],
            slidesPerView: 'auto',
            spaceBetween: 40,
            duration: 300,
            grabCursor: true,
            keyboard: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: this.getSlideHeight,
                resize: this.getSlideHeight,
            },
        });
    }

    destroy () {
        if (!this.slider) return;

        this.slider.destroy(true, true);
        this.slider = null;
    }
}
